import Vue from 'vue';
let vm = new Vue();

import Config from './config'
import Http from './http'
import wx from 'weixin-js-sdk';
import qs from 'qs';

// import { JSEncrypt } from 'jsencrypt'
// import { JSEncrypt } from 'encryptlong'

export default {
    wxTool(url,call){
        let _this = this;

        // console.log(window.location.href);

        // url = encodeURIComponent(url);

        Http.post({
            url: 'Common/getWxJsConfig',
            data: {url:url},
            success: (res) => {
                wx.config({
                    debug: false,
                    appId: res.appId,         // 必填，公众号的唯一标识
                    timestamp: res.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.nonceStr,   // 必填，生成签名的随机串
                    signature: res.signature, // 必填，签名，见附录1
                    jsApiList: [
                        'onMenuShareAppMessage',
                        'onMenuShareTimeline'
                    ]
                });

                wx.ready(function (){
                    if (call) {
                        call()
                    }
                })

                wx.error(function (res){
                    console.log(res);
                })
            }
        });
    },
    isWxImg(img) {
        if (img) {
            if (!/\.(gif|jpg|jpeg|png|GIF|JPEG|JPG|PNG)$/.test(img)) {
                return true;
            }

            return false;
        } else {
            return false;
        }
    },
    mustLetter(rule, value, callback){
        if (value === '') {
            return callback(new Error('不能为空'));
        }

        let _v = /[a-z0-9]$/;
        if (!_v.test(value)) {
            return callback(new Error('必须是小写字母或数字'));
        } else {
            return callback();
        }
    },
    mustNumber(rule, value, callback){
        if (value === '') {
            return callback(new Error('不能为空'));
        }

        let _v = /(^[1-9]\d*$)/;
        if (!_v.test(value)) {
            return callback(new Error('必须是整数'));
        } else {
            return callback();
        }
    },
    must09(rule, value, callback){
        if (value === '') {
            return callback(new Error('不能为空'));
        }

        // if (!Number.isInteger(value)) {
        //     return callback(new Error('请输入数字值'));
        // }

        if(value.length>1){
            let flagRex =/^0/;
            if(flagRex.test(value)){
                return callback(new Error('请输入正确的数字'));
            }
        }

        let _v = /(^[0-9]\d*$)/;
        if (!_v.test(value)) {
            return callback(new Error('必须是整数'));
        } else {
            return callback();
        }
    },
    biggerZero(rule, value, callback){
        if (value === '') {
            return callback(new Error('不能为空'));
        }

        if (!Number.isInteger(value) && typeof value !== 'number') {
            return callback(new Error('请输入数字值'));
        } else {
            if (value < 0) {
                return callback(new Error('必须>=0'));
            } else {
                return callback();
            }
        }
    },
    biggerZero2(rule, value, callback){
        if (value === '') {
            return callback(new Error('不能为空'));
        }

        // console.log(typeof value);
        if (!Number.isInteger(value) && typeof value !== 'number') {
            return callback(new Error('请输入数字值'));
        } else {
            if (value <= 0) {
                return callback(new Error('必须大于0'));
            } else {
                return callback();
            }
        }
    },
    rulePercent(rule, value, callback){
        if (value === '') {
            return callback(new Error('不能为空'));
        }

        let _v = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;

        if (!_v.test(value)) {
            return callback(new Error('请输入数字值'));
        } else {
            if (parseFloat(value) < 0 || parseFloat(value) > 100) {
                return callback(new Error('必须>=0 并且 <= 100'));
            } else {
                return callback();
            }
        }
    },
    rulePriceNotZero(rule, value, callback){
        if (value === '') {
            return callback(new Error('不能为空'));
        }

        let _v = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;

        if (!_v.test(value)) {
            return callback(new Error('请输入数字值'));
        } else {
            if (parseFloat(value) <= 0) {
                return callback(new Error('必须大于0'));
            } else {
                return callback();
            }
        }
    },
    rulePriceCanZero(rule, value, callback){
        if (value === '') {
            return callback(new Error('不能为空'));
        }

        let _v = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;

        if (!_v.test(value)) {
            return callback(new Error('请输入数字值'));
        } else {
            if (parseFloat(value) < 0) {
                return callback(new Error('必须大于0'));
            } else {
                return callback();
            }
        }
    },
    calcDescartes (array) {

        let res = [];
        let _arr = [];
        let skus = [];

        for(let i=0;i < array.length;i++){
            console.log(array[i].spec_value.length);
            if(array[i].spec_value.length > 0) {
                _arr.push(array[i].spec_value);
            }
        }


        if(_arr.length > 0) {
            if (_arr.length < 2) {

                for (let i = 0; i < _arr[0].length; i++) {
                    res.push([_arr[0][i]]);
                }
            } else {
                res = [].reduce.call(_arr, function (col, set) {
                    let _res = [];

                    col.forEach(function (c) {
                        set.forEach(function (s) {
                            let t = [].concat(Array.isArray(c) ? c : [c]);
                            t.push(s);
                            _res.push(t);

                        })
                    });

                    return _res;
                });
            }



            for (let k = 0; k < res.length; k++) {
                let _sku = [];
                for (let j = 0; j < res[k].length; j++) {
                    _sku.push({
                        id: array[j].id,
                        name: array[j].name,
                        value_id: res[k][j].id,
                        value_name: res[k][j].name
                    });
                }
                skus.push({spec: _sku, price: 0.00, stock: 0, code: '', img: ''});
            }

            return skus;
        }

        return skus;
    },
    checkParams(rule,val){
        for(let item in rule){
            if(rule[item].check === 'require'){
                if(this.isUndefined(val[item].trim())){
                    console.error('param '+item+' must be require!');
                    return false;
                }
            }

            if(typeof val[item] !== rule[item].type && !this.isUndefined(val[item])){
                console.error('param '+item+' must be '+rule[item].type+'!');
                return false;
            }
        }
        return true;
    },
    formatPrice(price){
        return (Math.floor(Number(price) * 100) / 100).toFixed(2);
    },
    isUndefined(variable) {
        return (typeof variable == 'undefined' || variable === null || variable === '');
    },
    localSet(key,val){
        if((typeof val === 'string' || typeof val === 'number') && typeof key === 'string') {
            return localStorage.setItem(key, val);
        }else{
            console.error('value & key must be a string!');
        }
        return false;
    },
    localGet(key){
        if(typeof key === 'string'){
            return localStorage.getItem(key);
        }else{
            console.error('key must be a string!');
        }
        return false;
    },
    localDel(key){
        if(typeof key === 'string'){
            return localStorage.removeItem(key);
        }else{
            console.error('key must be a string!');
        }
        return false;
    },
    localClear(){
        return localStorage.clear();
    },
    isWx(){
        var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
        if (ua.match(/MicroMessenger/i)) {
            return true;
        }
        return false;
    },
    isMobile(){
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/mobile/i)) {
            return true;
        }
        return false
    },
    querystring(data){
        return qs.stringify(data);
    },
    getWxCodeUrl(url){
        var authUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize';
        authUrl += '?appid=' + Config.WX_CONFIG.appId;
        authUrl += '&redirect_uri=' + encodeURIComponent(url);
        authUrl += '&response_type=code';
        authUrl += '&scope=snsapi_base';
        authUrl += '&state=state';
        return authUrl;
    },

    getFWWxCodeUrl(url){
        var authUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize';
        authUrl += '?appid=' + Config.WX_CONFIG.serviceAppId;
        authUrl += '&redirect_uri=' + encodeURIComponent(url);
        authUrl += '&response_type=code';
        authUrl += '&scope=snsapi_base';
        authUrl += '&state=state';
        return authUrl;
    },
    // rsaEncode(content){
    //
    //     // let encryptor = new JSEncrypt()
    //     //
    //     // encryptor.setPublicKey(key)
    //     //
    //     // let cptData = encryptor.encryptLong(data)
    //     //
    //     // return cptData
    //
    //     let encrypeJs = new JSEncrypt();
    //     encrypeJs.setPublicKey(Config.publicKey);
    //     // return encrypeJs.encryptLong(content);
    //     return encrypeJs.encrypt(content);
    // },
    // rsaDecode(content){
    //     let encrypeJs = new JSEncrypt();
    //     encrypeJs.setPublicKey(Config.publicKey);
    //     return encrypeJs.decrypt(content);
    // }
}
